//
//
//
//
//
//
//
//
//
//
//
//
//
//

import f_nav_bar from "@/components/nav_bar";
import search from "@/components/common_search";
import FlexList from "@/components/common_flexList.vue";
export default {
  components: { f_nav_bar, search, FlexList },
  data() {
    return {
      listConfig: {
        pageIndex: 1,
        pageSize: 6,
        totalPage: 1,
        listType: ''
      },
      flexList:[], //输出
      nav_bar: {
        cur: 0,
        list: [ { text: "收入" }, { text: "支出" }, { text: "全部" } ]
      },
      search_info: { text: "请输入单号", value: '' }
    };
  },

  created () {
    this.getCashRecords(
      this.listConfig.pageIndex, this.listConfig.pageSize, 0
    )
  },

  computed: {},
  methods: {
    getCashRecords (pageIndex, pageSize, actionType='', orderNo='') {
      this.$msg.loading()
      this.$http({
        url: this.$api.GetPassageNodeCashDataLogList,
        method: "Post",
        data: {
          PageIndex: pageIndex,
          PageSize: pageSize,
          CashActionType: actionType,
          OrderNo: orderNo,
        }
      }).then(res=>{
        this.$msg.hideLoading()
        if(res.data.state==1){
          this.listConfig.totalPage = res.data.data.TotalPages
          this.flexList = res.data.data.list.map(item => {
            return {
              topL: '现金红包', bottomL: item.UpdateOn, 
              topR: item.Money+'元', 
            }
          })
        }   
      })
    },

    switchNavBar (activeIndex) {
      this.nav_bar.cur = activeIndex;
      if (this.nav_bar.cur == 0) {
        this.flexList=[];
        this.listConfig.listType=0
        this.getCashRecords(
          this.listConfig.pageIndex, this.listConfig.pageSize, 0
        )
      } else if (this.nav_bar.cur == 1) {
        this.flexList=[];
        this.listConfig.listType=1
        this.getCashRecords(
          this.listConfig.pageIndex, this.listConfig.pageSize, 1
        )
      } else {
        this.flexList=[];
        this.listConfig.listType=''
        this.getCashRecords(
          this.listConfig.pageIndex, this.listConfig.pageSize
        )
      }
    },

    onInputChange () {
      console.log(this.search_info.value)
    },

    go_details (data) {
      if (this.nav_bar.cur==0) {
        this.$router.push({
          path: '/mSms/pointsHistoryDetails_income',
          query: {item_data:data}
        })
      } else if (this.nav_bar.cur==1) {
          this.$router.push({
            path: '/mSms/pointsHistoryDetails_outcome',
            query: {item_data:data}       
          })
      } else {
        this.flexList=[];
        this.$router.push({
          path: '/mSms/pointsHistoryDetails_outcome',
          query: {item_data:data}       
        })
      }
    },

    

  }
};
